import wuxalBackground from "../../images/wuxalBackground.jpg";
import danMeyers from "../../images/danMeyers.jpg";
import organicAgriculture from "../../images/organicAgriculture.jpg";
import challenges from "../../images/challenges.jpg";

export const stayUpToDate = [
  {
    image: wuxalBackground,
    label: "NEWS",
    article: "Betino® has received confirmation from Organic Standard",
    date: "31.08.2023",
    read: 5,
  },
  {
    image: danMeyers,
    label: "EVENT",
    article: 'Agro Conference "Organic agriculture"',
    date: "29.08.2023",
    read: 3,
  },
  {
    image: organicAgriculture,
    label: "ARTICLE",
    article: "Friendly seedlings under stressful conditions",
    date: "20.08.2023",
    read: 5,
  },
  {
    image: challenges,
    label: "RESEARCH",
    article: "Challenges of the 21st century",
    date: "25.08.2023",
    read: 5,
  },
];